import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import DrinkingWaterTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import { useTranslation } from "react-i18next";
import drinkingWaterIcon from "../../../../../assets/design-revamp-company/category-icons/drinking_water_icon.svg";
const DrinkingWaterContents = ({ businessId, systemBoundaryProps }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("DRINKING_WATER")}
        isNormal={true}
        number={"2.4.1"}
        icon={drinkingWaterIcon}
        showSystemBoundary={true}
        systemBoundaryProps={systemBoundaryProps}
      />
      {showTable && (
        <DrinkingWaterTable businessId={businessId} category={"used"} />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default DrinkingWaterContents;
